import DefaultLayout from '../containers/DefaultLayout';
import MyLoadable from '../hoc/MyLoadable';

const Dashboard = MyLoadable({
  loader: () => import('../../src/pages/Secure/Dashboard')
});

const SignIn = MyLoadable({
  loader: () => import('../pages/Login')
});

const Employee = MyLoadable({
  loader: () => import('../../src/pages/Secure/Employee')
});

const Agent = MyLoadable({
  loader: () => import('../../src/pages/Secure/Agent')
});

const Visitor = MyLoadable({
  loader: () => import('../../src/pages/Secure/Visitor')
});

const EmployeeDetails = MyLoadable({
  loader: () => import('../../src/pages/Secure/Employee/Details')
});

const NewEmployee = MyLoadable({
  loader: () => import('../../src/pages/Secure/Employee/New')
});

const EditEmployee = MyLoadable({
  loader: () => import('../../src/pages/Secure/Employee/Edit')
});

const AgentDetails = MyLoadable({
  loader: () => import('../../src/pages/Secure/Agent/Details')
});

const NewAgent = MyLoadable({
  loader: () => import('../../src/pages/Secure/Agent/NewAgent')
});

const EditAgent = MyLoadable({
  loader: () => import('../../src/pages/Secure/Agent/Edit')
});

const VisitorDetails = MyLoadable({
  loader: () => import('../../src/pages/Secure/Visitor/Details')
});

const NewVisitor = MyLoadable({
  loader: () => import('../../src/pages/Secure/Visitor/New')
});

const User = MyLoadable({
  loader: () => import('../../src/pages/Secure/User')
});

const NewUser = MyLoadable({
  loader: () => import('../pages/Secure/User/New')
});

const EditUser = MyLoadable({
  loader: () => import('../../src/pages/Secure/User/Edit')
});

const Chit = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit')
});

const NewChit = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/New')
});

const UserDetails = MyLoadable({
  loader: () => import('../../src/pages/Secure/User/Details')
});

const ChitDetails = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Details')
});

const ConvertVisitorToUser = MyLoadable({
  loader: () => import('../../src/pages/Secure/Visitor/ConvertToUser')
});

const Chitties = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/List')
});

const NewChitties = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/New')
});

const ChittiesDetail = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/Detail')
});

const ChittiesEdit = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/Edit')
});

const AddUser = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/AddUser')
});

const Auction = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/Auction')
});

const AuctionAddPayment = MyLoadable({
  loader: () =>
    import('../../src/pages/Secure/Chit/Chitties/AuctionPayment/Add')
});

const AuctionViewPayment = MyLoadable({
  loader: () =>
    import('../../src/pages/Secure/Chit/Chitties/AuctionPayment/View')
});

const PaymentList = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/DuePayment/List')
});

const PaymentDetail = MyLoadable({
  loader: () => import('../../src/pages/Secure/Chit/Chitties/DuePayment/Detail')
});

const DuePayment = MyLoadable({
  loader: () =>
    import('../../src/pages/Secure/Chit/Chitties/DuePayment/Payment')
});

const Accounts = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts')
});

const AuctionCheque = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/AuctionCheque')
});

const PaymentCheque = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/PaymentCheque')
});

const UnclearCheque = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/UnclearCheque')
});

const AuctionChequeList = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/AuctionCheque/List')
});

const PaymentChequeList = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/PaymentCheque/List')
});

const AuctionReport = MyLoadable({
  loader: () => import('../../src/pages/Secure/Report/Auction')
});

const AuctionChequeDetail = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/AuctionCheque/Detail')
});

const PaymentChequeDetail = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/PaymentCheque/Detail')
});

const UnclearChequeDetail = MyLoadable({
  loader: () => import('../../src/pages/Secure/Accounts/UnclearCheque/Detail')
});

const CollectionReport = MyLoadable({
  loader: () => import('../../src/pages/Secure/Report/Collection')
});

const PendingReport = MyLoadable({
  loader: () => import('../../src/pages/Secure/Report/PendingDues')
});

const Minutes = MyLoadable({
  loader: () => import('../../src/pages/Secure/Reminders/Minutes')
});

const ChitClosure = MyLoadable({
  loader: () => import('../../src/pages/Secure/Reminders/ChitClosure')
});

const ReceiptBook = MyLoadable({
  loader: () => import('../../src/pages/Secure/Receipts')
});

const Profile = MyLoadable({
  loader: () => import('../../src/pages/Secure/Profile')
});

const ProfileEdit = MyLoadable({
  loader: () => import('../../src/pages/Secure/Profile/Edit')
});

const BankAdd = MyLoadable({
  loader: () => import('../../src/pages/Secure/Profile/Bank/Add')
});

const BankView = MyLoadable({
  loader: () => import('../../src/pages/Secure/Profile/Bank/View')
});

const BankEdit = MyLoadable({
  loader: () => import('../../src/pages/Secure/Profile/Bank/Edit')
});

const routes = [
  {
    path: '/',
    exact: true,
    name: 'Home',
    component: DefaultLayout
  },
  {
    path: '/signin',
    exact: true,
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/dashboard',
    exact: true,
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/employees',
    exact: true,
    name: 'Employees',
    component: Employee
  },
  {
    path: '/agents',
    exact: true,
    name: 'Agents',
    component: Agent
  },
  {
    path: '/employees/new',
    exact: true,
    name: 'New',
    component: NewEmployee
  },
  {
    path: '/employees/:id',
    exact: true,
    name: 'Details',
    component: EmployeeDetails
  },
  {
    path: '/employees/edit/:id',
    exact: true,
    name: 'Edit',
    component: EditEmployee
  },
  {
    path: '/agents/new',
    exact: true,
    name: 'New',
    component: NewAgent
  },
  {
    path: '/agents/edit/:id',
    exact: true,
    name: 'Edit',
    component: EditAgent
  },
  {
    path: '/agents/new',
    exact: true,
    name: 'New',
    component: NewAgent
  },
  {
    path: '/agents/:id',
    exact: true,
    name: 'Details',
    component: AgentDetails
  },
  {
    path: '/visitors',
    exact: true,
    name: 'Visitors',
    component: Visitor
  },
  {
    path: '/visitors/new',
    exact: true,
    name: 'New',
    component: NewVisitor
  },
  {
    path: '/visitors/:id',
    exact: true,
    name: 'Details',
    component: VisitorDetails
  },
  {
    path: '/chits',
    exact: true,
    name: 'Chits',
    component: Chit
  },
  {
    path: '/chits/new',
    exact: true,
    name: 'New',
    component: NewChit
  },
  {
    path: '/users',
    exact: true,
    name: 'Users',
    component: User
  },
  {
    path: '/users/new',
    exact: true,
    name: 'New',
    component: NewUser
  },
  {
    path: '/users/:id',
    exact: true,
    name: 'Details',
    component: UserDetails
  },
  {
    path: '/chits/:id',
    exact: true,
    name: 'Details',
    component: ChitDetails
  },
  {
    path: '/users/edit/:id',
    exact: true,
    name: 'Edit',
    component: EditUser
  },
  {
    path: '/visitors/convertVisitor/:id',
    exact: true,
    name: 'Visitor',
    component: ConvertVisitorToUser
  },
  {
    path: '/chitties/:id/new',
    exact: true,
    name: 'New',
    component: NewChitties
  },
  {
    path: '/chitties/list/:id',
    exact: true,
    name: 'Chitties',
    component: Chitties
  },
  {
    path: '/chitties/:id/addUser',
    exact: true,
    name: 'Add User',
    component: AddUser
  },
  {
    path: '/chitties/list/:chitId/detail/:chittyId',
    exact: true,
    name: 'ChittiesDetail',
    component: ChittiesDetail
  },
  {
    path: '/chitties/list/:chitId/edit/:chittyId',
    exact: true,
    name: 'ChittiesEdit',
    component: ChittiesEdit
  },
  {
    path: '/chitties/:chitId/auction/:chittieId',
    exact: true,
    name: 'Auction',
    component: Auction
  },
  {
    path: '/chitties/:chittieId/auction/:auctionId/addPayment',
    exact: true,
    name: 'AddPayment',
    component: AuctionAddPayment
  },
  {
    path: '/chitties/:chittieId/auction/:auctionId/viewPayment',
    exact: true,
    name: 'ViewPayment',
    component: AuctionViewPayment
  },
  {
    path: '/chitties/:chitId/paymentList/:chittieId',
    exact: true,
    name: 'PaymentList',
    component: PaymentList
  },
  {
    path:
      '/chitties/paymentDetail/:month/customer/:userId/:chitId/:chittieId',
    exact: true,
    name: 'Detail',
    component: PaymentDetail
  },
  {
    path:
      '/chitties/duePayment/:month/customer/:userId/:chitId/:chittieId',
    exact: true,
    name: 'Due',
    component: DuePayment
  },
  {
    path: '/accounts',
    exact: true,
    name: 'Accounts',
    component: Accounts
  },
  {
    path: '/auctionCheque',
    exact: true,
    name: 'AuctionCheque',
    component: AuctionCheque
  },
  {
    path: '/paymentCheque',
    exact: true,
    name: 'PaymentCheque',
    component: PaymentCheque
  },
  {
    path: '/unclearCheque/:chittieId',
    exact: true,
    name: 'UnclearCheque',
    component: UnclearCheque
  },
  {
    path: '/auctionChequeList/:chittieId',
    exact: true,
    name: 'AuctionChequeList',
    component: AuctionChequeList
  },
  {
    path: '/paymentChequeList/:chittieId',
    exact: true,
    name: 'PaymentChequeList',
    component: PaymentChequeList
  },
  {
    path: '/report',
    exact: true,
    name: 'Report',
    component: AuctionReport
  },
  {
    path: '/report/auction',
    name: 'AuctionReport',
    component: AuctionReport
  },
  {
    path: '/auctionChequeDetail/:auctionId',
    exact: true,
    name: 'AuctionChequeDetail',
    component: AuctionChequeDetail
  },
  {
    path: '/paymentChequeDetail/:paymentId/:transactionId',
    exact: true,
    name: 'PaymentChequeDetail',
    component: PaymentChequeDetail
  },
  {
    path: '/unclearChequeDetail/:paymentId/:transactionId',
    exact: true,
    name: 'UnclearChequeDetail',
    component: UnclearChequeDetail
  },
  {
    path: '/report/collection',
    name: 'CollectionReport',
    component: CollectionReport
  },
  {
    path: '/report/dues',
    exact: true,
    name: 'PendingDues',
    component: PendingReport
  },
  {
    path: '/minutes',
    exact: true,
    name: 'Minutes Reminder',
    component: Minutes
  },
  {
    path: '/chitClosure',
    exact: true,
    name: 'Chit Closure',
    component: ChitClosure
  },
  {
    path: '/receipts',
    exact: true,
    name: 'Receipt Book',
    component: ReceiptBook
  },
  {
    path: '/profile',
    exact: true,
    name: 'Profile',
    component: Profile
  },
  {
    path: '/profile/edit/:id',
    exact: true,
    name: 'Profile Edit',
    component: ProfileEdit
  },
  {
    path: '/profile/:id/bank/add',
    exact: true,
    name: 'Bank',
    component: BankAdd
  },
  {
    path: '/bank/:id/view',
    exact: true,
    name: 'View',
    component: BankView
  },
  {
    path: '/bank/:profileKey/edit/:id',
    exact: true,
    name: 'Edit',
    component: BankEdit
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/config/routes.js